export default __webpack_public_path__ + "static/media/images.png?.626bf44d";